import type {
  DehydratedState,
  VueQueryPluginOptions,
} from '@tanstack/vue-query'
import { AUTH_ERRORS } from '@foodlista/shared/auth/constants'

import {
  dehydrate,
  hydrate,
  MutationCache,
  QueryClient,
  VueQueryPlugin,
} from '@tanstack/vue-query'
import { USERS_CACHE_KEYS } from '~/domains/users/queries'

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>('vue-query')
  const localePath = useLocalePath()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10000,
        throwOnError: true,
      },
    },
    mutationCache: new MutationCache({
      onSuccess: async () => {
        await refreshNuxtData(USERS_CACHE_KEYS.userProfile)
      },
      onError: async (error) => {
        if (error.message === AUTH_ERRORS.session_missing) {
          await navigateTo(localePath('/login'))
        }
      },
    }),
  })

  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (import.meta.server) {
    nuxt.hooks.hook('app:rendered', () => {
      vueQueryState.value = dehydrate(queryClient)
    })
  }

  if (import.meta.client) {
    nuxt.hooks.hook('app:created', () => {
      hydrate(queryClient, vueQueryState.value)
    })
  }
})
